/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Today_Checkin_TitleInputs */

const en_us2_today_checkin_title = /** @type {(inputs: Today_Checkin_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Post-workout check-in`)
};

const pt_br2_today_checkin_title = /** @type {(inputs: Today_Checkin_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Check-in depois do treino`)
};

const es_419_today_checkin_title = /** @type {(inputs: Today_Checkin_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Check-in después del entrenamiento`)
};

const pt_pt2_today_checkin_title = /** @type {(inputs: Today_Checkin_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Check-in depois do treino`)
};

const fr_fr2_today_checkin_title = /** @type {(inputs: Today_Checkin_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bilan après la séance`)
};

const de_de2_today_checkin_title = /** @type {(inputs: Today_Checkin_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Check-in nach dem Training`)
};

const it_it2_today_checkin_title = /** @type {(inputs: Today_Checkin_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Check-in dopo l'allenamento`)
};

/**
* | output |
* | --- |
* | "Post-workout check-in" |
*
* @param {Today_Checkin_TitleInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const today_checkin_title = /** @type {((inputs?: Today_Checkin_TitleInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Today_Checkin_TitleInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_today_checkin_title(inputs)
	if (locale === "es-419") return es_419_today_checkin_title(inputs)
	if (locale === "pt-PT") return pt_pt2_today_checkin_title(inputs)
	if (locale === "fr-FR") return fr_fr2_today_checkin_title(inputs)
	if (locale === "de-DE") return de_de2_today_checkin_title(inputs)
	if (locale === "it-IT") return it_it2_today_checkin_title(inputs)
	return en_us2_today_checkin_title(inputs)
});
export { today_checkin_title as "today.checkin_title" }